<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Michael Kevin Reed was born and raised in St. Louis, Missouri. Graduated from Lindenwood and Capella Universities, his passion for a great story and his fascination with the human condition led him to pursue writing and the creation of his first novel, <em>A Taste of Freedom</em>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?d83dc538